<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="transactionDt"
                    format="DD-MMM-YYYY"
                    allowClear
                    :disabled="disabled.transactionDt"
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                    :disabled="disabled.status"
                  >
                    <a-select-option value="delivered"
                      >Delivered</a-select-option
                    >
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process"
                      >On Process</a-select-option
                    >
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :tabbedTransactional="true"
        :isTransactional="true"
        :loading="loading"
        title="PD Activity Report List"
        createLink="lapKegPdListCreate"
        manifestLink="manifestLapPD"
        editLink="lapKegPdEdit"
        draftEditLink="lapKegPdEditDraft"
        :draftDeleteLink="true"
        :dataList="searching.list"
        :draftList="searching.draft"
        :allowcancel="true"
      >
        <template slot="row_extra" slot-scope="item">
          <a-tag
            :color="item.item.status_hrd.includes('Has Been') ? 'green' : 'orange'"
            class="margin-remove"
          >{{ item.item.status_hrd }}</a-tag>
        </template>
      </DataList>
    </a-col>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import Status from "@/components/Status.vue";
import GlobalMethod from "@/mixins/GlobalMethod";
import _ from "lodash";

export default {
  name: "listLapKegPd",
  components: { Status },
  mixins: [GlobalMethod],
  data() {
    return {
      loading: true,
      dataList: {
        list: [],
        draft: []
      },
      search: "",
      status: undefined,
      transactionDt: [],
      activetab: "list",
      disabled: {
        transactionDt: false,
        status: false
      }
    };
  },
  mounted() {
    this.fetchData();
    Event.$on("emitDeleteLink", this.deleteDraft);
    Event.$on("callbackTab", this.clickTabed);
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("emitDeleteLink", this.deleteDraft);
    Event.$off("callbackTab", this.clickTabed);
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getDefaultDateFormat"]),
    searching: function () {
      const self = this;
      let output = {
        list: this.dataList.list,
        draft: this.dataList.draft,
      };
      if (this.activetab == "list") {
        if (this.search) {
          output.list = output.list.filter(
            (obj) =>
              obj.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
              obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
        }

        if (this.status) {
          output.list = output.list.filter(
            (obj) =>
              obj.status && obj.status.toLowerCase().indexOf(this.status) >= 0
          );
        }

        if (self.transactionDt.length > 0 && self.transactionDt[0]!=null  && self.transactionDt[1] != null) {
          let startDt = moment(self.transactionDt[0]).format(
            this.getDefaultDateFormat
          );
          let endDt = moment(self.transactionDt[1]).format(
            this.getDefaultDateFormat
          );
          output.list = output.list.filter(
            (obj) =>
              moment(obj.tgl_mulai).format(this.getDefaultDateFormat) >=
              startDt &&
              moment(obj.tgl_selesai).format(this.getDefaultDateFormat) <= endDt
          );
        }
      } else {
        if (this.search) {
          output.draft = output.draft.filter(
            (obj) =>
              obj.Qsearch.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
        }
      }

      return output;
    },

    // dataListOutput() {
    //   let output = [];
    //   this.sppdList.forEach((data) => {
    //     output.push({
    //       title: data.no_pdlk,
    //       timeline: JSON.parse(data.status_app),
    //       unread: data.unread == "1" ? true : false,
    //       subdesc: [
    //         [
    //           {
    //             label: "Tanggal Pelaporan",
    //             value: moment(data.tgl_buat).format(this.getDefaultDateFormat),
    //           },
    //         ],
    //         [
    //           {
    //             label: "Tanggal Dinas",
    //             value:
    //               moment(data.tgl_mulai).format(this.getDefaultDateFormat) +
    //               " - " +
    //               moment(data.tgl_selesai).format(this.getDefaultDateFormat),
    //           },
    //         ],
    //         { deskripsi: data.deskripsi },
    //       ],
    //       status: data.status,
    //       id: data.id_pdlk,
    //       kode_project: data.kode_project,
    //       cancelStatus: data.cancel_sts
    //         ? data.cancel_sts == 1
    //           ? "Canceled"
    //           : null
    //         : null,
    //     });
    //   });

    //   return output;
    // },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "Lap_kegiatan_pd",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.dataList.list = [];
          response.data.data.forEach((data) => {
            this.dataList.list.push({
              title: data.no_pdlk,
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              deskripsi: data.deskripsi,
              tgl_mulai: data.tgl_mulai,
              tgl_selesai: data.tgl_selesai,
              subdesc: [
                [
                  {
                    label: "Tanggal Pelaporan",
                    value: moment(data.tgl_laporan).format(
                      this.getDefaultDateFormat
                    ),
                  },
                ],
                [
                  {
                    label: "Tanggal Dinas",
                    value:
                      moment(data.tgl_mulai).format(this.getDefaultDateFormat) +
                      " - " +
                      moment(data.tgl_selesai).format(
                        this.getDefaultDateFormat
                      ),
                  },
                ],
                "Deskripsi : " + data.deskripsi ,
              ],
              status: data.status,
              id: data.id_pdlk,
              kode_project: data.kode_project,
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1
                  ? "Canceled"
                  : null
                : null,
              row_extra: true,
              status_hrd: data.status_hrd
            });
          });

          response.data.draft.forEach((data) => {
            this.dataList.draft.push({
              title: data.no_sppd,
              subdesc: [
                "Tanggal Pelaporan : " + moment(data.tgl_laporan).format(
                  this.getDefaultDateFormat
                ),
                "Tanggal Dinas : " + moment(data.tgl_mulai).format(this.getDefaultDateFormat) +
                " - " +
                moment(data.tgl_selesai).format(
                  this.getDefaultDateFormat
                ),
                "Alokasi : "+ data.allocation,
                "Deskripsi : " + data.deskripsi
              ],
              status: data.status,
              id: data.id_pdlk,
              loading_delete: false,
              Qsearch : data.deskripsi+ " "+ data.no_sppd + " " + data.alokasi
              });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "pdlk",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.fetchData();
          this.searching;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    clickTabed(val) {
      this.activetab = val;
      if (val == "draft") {
        this.transactionDt = [null,null];
        this.status = undefined;
        this.disabled.transactionDt = true;
        this.disabled.status = true;
      } else {
        this.disabled.transactionDt = false;
        this.disabled.status = false;
      }
    },
    deleteDraft(val) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let indx = _.findIndex(that.dataList.draft, (e) => { return e.id == val.id })
          that.dataList.draft[indx].loading_delete = true;
          that.asyncAxiosDelete(
            "lap_kegiatan_pd/pdlk",
            "application/json",
            that.getAuth,
            {
              id_pdlk: val.id,
            }
          )
            .then(() => {
              that.dataList.draft = _.filter(that.dataList.draft, (e) => e.id != val.id)
            })
            .catch((err) => {
              console.log(err)
              that.dataList.draft[indx].loading_delete = false;
            });
        },
        onCancel() { },
      })
    }
  },
};
</script>

<style lang="less">
.ant-list-item {
  &-action {
    background-color: whitesmoke;
    padding: 5px 0;
  }
}
</style>
